import { render, staticRenderFns } from "./TopCards.vue?vue&type=template&id=15833c02&scoped=true&"
import script from "./TopCards.vue?vue&type=script&lang=js&"
export * from "./TopCards.vue?vue&type=script&lang=js&"
import style0 from "./TopCards.vue?vue&type=style&index=0&id=15833c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15833c02",
  null
  
)

export default component.exports